import { PARTNER_TYPES } from "@kiwicom/frontend-common/consts/booking"
import { PartnerType } from "@kiwicom/frontend-common/types/primitiveTypes"

import {
  InvalidDataReceiveAction,
  GeneralModule,
} from "../../../../../../../services/tracking/constants/trackingEvents"
import mmbTrack from "../../../../../../../services/tracking/mmbTrack"
import { PartnerTypeInput } from "../../../../../../../records/bookingInput"

export default function mapperPartnerType(partnerTypeInput: PartnerTypeInput): PartnerType {
  switch (partnerTypeInput) {
    case "b2b":
      return PARTNER_TYPES.B2B
    case "b2c":
      return PARTNER_TYPES.B2C
    case "b2b2c":
      return PARTNER_TYPES.B2B2C
    case "internal":
      return PARTNER_TYPES.INTERNAL
    case "unknown":
      return PARTNER_TYPES.UNKNOWN
    default:
      mmbTrack(
        {
          module: GeneralModule,
          action: InvalidDataReceiveAction,
          detail: "unexpected partner type",
        },
        { partnerType: partnerTypeInput },
      )
      return PARTNER_TYPES.UNKNOWN
  }
}
